(() => {
  if (window.__crVitrinaListo) return;
  window.__crVitrinaListo = true;
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const track = root.querySelector('[data-cr-vit-pista]');
    const slides = [...root.querySelectorAll('[data-cr-vit-slide]')];
    if (!track || slides.length < 2) return;
    const dots = [...root.querySelectorAll('[data-cr-vit-punto]')];
    const pause = root.querySelector('[data-cr-vit-pause]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const events = new AbortController();
    let current = 0, timer, settling, frame, hover = false, focus = false, visible = false, held = false;
    let stopped = root.dataset.crVitAuto !== '1' || motion.matches;
    const on = (target, type, handler, options = {}) => target.addEventListener(type, handler, {...options, signal:events.signal});
    const offset = i => slides[i].offsetLeft - slides[0].offsetLeft;
    function clear() { clearTimeout(timer); timer = undefined; }
    function controls() {
      if (!pause) return;
      pause.textContent = stopped ? 'Reanudar' : 'Pausar';
      pause.setAttribute('aria-label', stopped ? 'Reanudar carrusel' : 'Pausar carrusel');
      pause.setAttribute('aria-pressed', String(stopped));
      track.setAttribute('aria-live', stopped ? 'polite' : 'off');
    }
    function fitHeight() {
      if (matchMedia('(max-width:749px)').matches) {
        const height = Math.ceil(slides[current].getBoundingClientRect().height);
        if (height > 0 && track.style.height !== height + 'px') track.style.height = height + 'px';
      } else track.style.removeProperty('height');
    }
    function paint() {
      fitHeight();
      dots.forEach((dot,i) => i === current ? dot.setAttribute('aria-current','true') : dot.removeAttribute('aria-current'));
      slides.forEach((slide,i) => { slide.inert = i !== current; slide.setAttribute('aria-hidden',String(i !== current)); });
    }
    function schedule() {
      clear();
      if (stopped || hover || focus || !visible || held || document.hidden || root.querySelector('.cr-scene-point[open]')) return;
      const seconds = Number(slides[current].dataset.crVitDuration) || Number(root.dataset.crVitSegundos) || 6;
      timer = setTimeout(() => go(current + 1), seconds * 1000);
    }
    function go(index, smooth = true) {
      clear();
      const previous = current;
      current = (index + slides.length) % slides.length;
      paint();
      const wrap = Math.abs(current - previous) > 1;
      track.scrollTo({left:offset(current),behavior:smooth && !wrap && !motion.matches ? 'smooth' : 'instant'});
      clearTimeout(settling);
      settling = setTimeout(schedule, 500);
    }
    on(track,'scroll',() => {
      clear(); clearTimeout(settling);
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const nearest = slides.reduce((best,slide,i) => Math.abs(track.scrollLeft-offset(i)) < Math.abs(track.scrollLeft-offset(best)) ? i : best,0);
        current = nearest; paint();
      });
      settling = setTimeout(schedule,180);
    },{passive:true});
    on(root,'pointerenter',e => { if(e.pointerType === 'mouse'){hover=true;clear();} });
    on(root,'pointerleave',e => { if(e.pointerType === 'mouse'){hover=false;schedule();} });
    on(root,'focusin',() => {focus=true;clear();});
    on(root,'focusout',e => {if(!root.contains(e.relatedTarget)){focus=false;schedule();}});
    on(track,'pointerdown',() => {held=true;clear();},{passive:true});
    on(window,'pointerup',() => {if(held){held=false;schedule();}},{passive:true});
    on(window,'pointercancel',() => {held=false;schedule();},{passive:true});
    dots.forEach((dot,i) => on(dot,'click',() => go(i)));
    const prev=root.querySelector('[data-cr-vit-prev]'),next=root.querySelector('[data-cr-vit-next]');
    if(prev) on(prev,'click',() => go(current-1));
    if(next) on(next,'click',() => go(current+1));
    if(pause) on(pause,'click',() => {stopped=!stopped;controls();schedule();});
    on(track,'keydown',e => {
      if(e.target !== track) return;
      if(e.key === 'ArrowRight'){e.preventDefault();go(current+1);}
      if(e.key === 'ArrowLeft'){e.preventDefault();go(current-1);}
      if(e.key === 'Home'){e.preventDefault();go(0);}
      if(e.key === 'End'){e.preventDefault();go(slides.length-1);}
    });
    on(root,'toggle',schedule,{capture:true});
    on(document,'visibilitychange',schedule);
    on(motion,'change',() => {stopped=motion.matches || root.dataset.crVitAuto !== '1';controls();schedule();});
    const observer=new IntersectionObserver(entries => {visible=entries[0].isIntersecting;schedule();},{threshold:.25});
    observer.observe(root);
    let trackWidth = track.clientWidth;
    const resize=new ResizeObserver(() => {
      if (track.clientWidth !== trackWidth) { trackWidth = track.clientWidth; go(current,false); }
    });
    resize.observe(track);
    const contentResize = new ResizeObserver(fitHeight);
    slides.forEach(slide => contentResize.observe(slide));
    on(document,'shopify:block:select',e => {
      const index=slides.findIndex(slide => slide.contains(e.target) || slide === e.target);
      if(index >= 0){stopped=true;controls();go(index,false);}
    });
    on(document,'shopify:block:deselect',e => {
      if(!root.contains(e.target)) return;
      stopped=motion.matches || root.dataset.crVitAuto !== '1';controls();schedule();
    });
    controls();paint();schedule();
    instances.set(root,() => {clear();clearTimeout(settling);cancelAnimationFrame(frame);events.abort();observer.disconnect();resize.disconnect();contentResize.disconnect();instances.delete(root);});
  }
  const mountAll=() => document.querySelectorAll('[data-cr-vit]').forEach(mount);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mountAll,{once:true}); else mountAll();
  document.addEventListener('shopify:section:load',mountAll);
  document.addEventListener('shopify:section:unload',e => {
    for(const [root,dispose] of instances) if(e.target.contains(root)) dispose();
  });
})();

